import {
  FaArrowLeft,
} from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { Container } from './styles';

const GoBack = () => {
  const history = useHistory();
  return (
    <Container onClick={() => history.goBack()}>
      <FaArrowLeft />
      <strong style={{ fontFamily: 'Inter' }}>Voltar</strong>
    </Container>
  );
};
export default GoBack;
